export default __webpack_public_path__ + "static/media/mid_rigth_arrow.4bdaac09.svg";